import { CalculatorInput } from 'containers/calculator/components/CalculatorInput'
import { CalculatorResult } from 'containers/calculator/components/CalculatorResult'
import { WithCalculatorInput } from 'containers/calculator/hooks/useCalculatorInput'
import styles from 'containers/calculator/styles/page.module.css'

const CalculatorPageInner = () => {
    return (
        <div className={styles['page-container']}>
            <div className={styles['calculator-container']}>
                <CalculatorInput />
                <CalculatorResult />
            </div>
        </div>
    )
}
const css = `
html{
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    
}
body{
    overflow:hidden;
    position: relative;
    min-height: 100%;
}
:where(*, *::before, *::after) {
    border-width: 0;
    border-style: solid;
    box-sizing: border-box;
    word-wrap: break-word;
    margin:0;
    padding:0;
}
:where(img, video) {
    max-width: 100%;
    height: auto;
}

`

export const CalculatorPage = () => {
    return (
        <WithCalculatorInput>
            <style>{css}</style>
            <CalculatorPageInner />
        </WithCalculatorInput>
    )
}
